import styled from 'styled-components';
import View from '@sdk/components/primitives/View';
import FlexCenteredStyle from '@sdk/components/ui/FlexCenteredStyle';
import Column from '@sdk/components/ui/spacing/Column';
import TextInputBase from '@sdk/components/forms/TextInputBase';
import IconButton from '@sdk/components/ui/buttons/IconButton';

export const InputWithPointer = styled(TextInputBase)`
  cursor: pointer;
`;

export const ChevronContainer = styled(View)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding-right: 14px;
  ${FlexCenteredStyle};
`;

export const Container = styled(Column)<{ customWidth?: number }>`
  position: relative;
  border-radius: 4px;
  flex: 1;
  cursor: pointer;
  ${({ customWidth }): string => (customWidth ? `width: ${customWidth}px;` : '')}
`;

export const InputContainer = styled(Column)`
  position: relative;
  cursor: pointer;
  background: ${({ theme }): string => theme.colors.white};
  flex: 2;
`;

export const TrashButton = styled(IconButton)`
  max-width: 36px;
  margin-left: 10px;
  background-color: ${({ theme }) => theme.colors.white};
`;
